import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store, persistor } from "./redux/store";
import axios from "axios";
import "./locales/i18n";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { ThemeContext } from "./contexts/ThemeContext";
import { LocationProvider } from "./contexts/LocationContext";

import { SettingsProvider } from "./contexts/SettingsContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./locales/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
const errorHandler = (err) => {
  if (
    err.response?.status === 498 ||
    err.response.data?.message === "User Not Authenticated."
  ) {
    localStorage.setItem("expiredToken", err.response.data?.message);
    localStorage.removeItem("user");
    localStorage.removeItem("linkId");
    localStorage.removeItem("linkData");

    window.location = "/auth/login";
  } else {
    // toast.error(err.response.data.message);
  }
  return;
};

axios.interceptors.request.use(
  (req) =>
    // Add configurations here
    req,
  (err) => {
    if (
      err.response?.status === 498 ||
      err.response.data?.message === "User Not Authenticated."
    ) {
      localStorage.setItem("expiredToken", err.response.data?.message);
      localStorage.removeItem("linkData");
      localStorage.removeItem("user");
      localStorage.removeItem("linkId");
      window.location = "/auth/login";
      return Promise.reject(err);
    }
    return false;
  }
);

// For POST requests
axios.interceptors.response.use(
  (res) => {
    // Add configurations here
    if (res.status === 200) {
      // console.log('Posted Successfully');
    }
    return res;
  },
  (err) => {
    errorHandler(err);
    // console.log(err, "errrors");
  }
);

//facebook pixel

root.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <SettingsProvider>
          <ThemeContext>
            <LocationProvider>
              <App tab="home" />
            </LocationProvider>
          </ThemeContext>
        </SettingsProvider>
      </I18nextProvider>
    </PersistGate>
  </ReduxProvider>
);
